import { capitalize } from 'utils/helpers'
import { SALUTATIONS } from 'components/common/modals/ContactModalContainer/constants'

export const toContactData = data => {
  const {
    contact,
    roles,
    contactActiveDeals,
    contactLostDeals,
    contactLostProposals,
    contactClosedDeals,
    contactWonDeals,
    contactWonProposals,
    contactProjectDeals,
    contactActiveProposals,
    contactPipeline,
    companyActiveDeals,
    companyPipeline
  } = data
  return {
    contact,
    roles,
    deals: contactActiveDeals,
    lostDeals: contactLostDeals,
    projectDeals: contactProjectDeals,
    closedDeals: contactClosedDeals,
    wonDeals: contactWonDeals,
    proposals: contactActiveProposals,
    wonProposals: contactWonProposals,
    lostProposals: contactLostProposals,
    pipeline: contactPipeline,
    companyDeals: companyActiveDeals,
    companyPipeline
  }
}

export const toContactDeals = deals => {
  return deals.map(deal => {
    const { id, name, dueDate, status, value, dealManager, followUpDate } = deal
    return {
      dealId: id,
      name,
      dueDate,
      status,
      value,
      dealManager,
      followUpDate
    }
  })
}

const toCompanySelectValue = company => ({
  value: company.id,
  label: company.name
})

const toStatusSelectValue = status => ({
  label: status.name,
  value: status.id
})

const toPrioritySelectValue = priority => ({
  label: capitalize(priority),
  value: priority.toLowerCase()
})

export const toEditContactData = contact => {
  const {
    id,
    firstName,
    lastName,
    salutation,
    title,
    company,
    status,
    priority,
    birthday,
    partner,
    partnerBirthday,
    label,
    photo,
    phone,
    phoneExt,
    fax,
    email,
    facebook,
    linkedin,
    twitter,
    instagram,
    cellPhone,
    about,
    accountOwner
  } = contact
  return {
    id,
    firstName,
    lastName,
    salutation: SALUTATIONS.find(s => s.value === salutation),
    phoneExt,
    fax,
    title,
    company: toCompanySelectValue(company),
    status: status ? toStatusSelectValue(status) : '',
    priority: priority ? toPrioritySelectValue(priority) : '',
    birthday,
    partner,
    partnerBirthday,
    label,
    photo,
    phone,
    email,
    facebook,
    linkedin,
    twitter,
    instagram,
    cellPhone,
    about,
    accountOwner: accountOwner ? { value: accountOwner.id, label: accountOwner.userName } : null
  }
}

export const toEmailTemplatesSelect = templates =>
  templates.map(template => ({
    value: template.id,
    label: template.name
  }))

const toCCRecipients = contacts =>
  contacts.reduce((acc, cur) => {
    if (!acc[cur.type]) {
      acc[cur.type] = []
    }
    acc[cur.type].push(cur.value)
    return acc
  }, {})

export const toContactEmail = (
  fromUser,
  toContact,
  ccContacts,
  bccContacts,
  subject,
  emailBody,
  files,
  fromContactsList,
  withSaveEmailAsNote,
  entityId,
  splitMode,
  app
) => {
  const ccRecipients = ccContacts.length ? toCCRecipients(ccContacts) : []

  const formData = new FormData()
  formData.append(
    app === 'leads' ? 'to' : 'toContacts',
    Array.isArray(toContact)
      ? toContact.map(contact => (app === 'leads' ? contact.email : contact.id))
      : [toContact.id]
  )
  formData.append('ccContacts', ccRecipients.contacts || [])
  formData.append('ccUsers', ccRecipients.users || [])
  formData.append('bccContacts', bccContacts.split(/[ ,;]+/))
  formData.append('subject', subject)
  formData.append('emailBody', emailBody)
  formData.append('splitMode', splitMode)

  if (fromContactsList) {
    formData.append('fromContactsList', fromContactsList)
  }

  if (withSaveEmailAsNote) {
    formData.append('dealId', entityId)
  }

  if (fromUser) {
    formData.append('from', fromUser.value)
  }

  files.forEach(file => {
    formData.append('attachments', file)
  })

  return formData
}

export const toFormData = (contactId, files, note, dateEntered) => {
  const formData = new FormData()
  formData.append('contactId', contactId)
  formData.append('note', note)
  formData.append('dateEntered', dateEntered)
  files.forEach(file => {
    if (!file.id) {
      formData.append('newAttachments', file)
    } else {
      formData.append('attachmentIds', file.id)
    }
  })

  return formData
}
